import {h, Fragment} from "preact"
import { useAppStateSelector, useSort, pick, useFacets } from '@nosto/preact'
import Facet from './Facet'
import RangeFacet from './RangeFacet'
import Select from './elements/Select'
import SelectedFilters from './SelectedFilters'
import { sortOptions } from '../config'

export const toggleButtonId = 'toggle-mobile-sidebar'

export default function SideBar() {
    const { loading, query, response, pageType } = useAppStateSelector((state) =>
        pick(state, 'loading', 'query', 'response', 'pageType')
    )
    const { facets } = useFacets()

    const { activeSort, setSort } = useSort(sortOptions)
    const handleSortChange = (event) => {
        setSort(event.target.value)
    }

    const docCount = response.products?.total ?? 0

    const options = sortOptions.map((o) => ({ value: o.id, label: o.value.name }))

    return facets?.length > 0 ? (
        <div data-section-type="collection-sidebar" data-combine-tags="true" data-style="custom">
            <div class="collection-filter_customtitle">
                <h4 class="filters-title">Rajaa hakuehtoja</h4>
            </div>
            <div class="collection-sidebar">
                <SelectedFilters />
                <div class="collection-sidebar__group--collection-template">
                    {facets?.map((facet) => {
                        switch (facet.type) {
                            case 'terms':
                                return <Facet key={facet.id} facet={facet} />
                            case 'stats':
                                return <RangeFacet key={facet.id} facet={facet} />
                            default:
                                return null
                        }
                    })}
                </div>
                <div class="count-and-sort">
                    <div class="collection-filter__sort-container">
                        <label for="SortByAlt" class="hidden-label">
                            {activeSort}
                        </label>
                        <Select
                            value={activeSort}
                            onChange={(e) => handleSortChange(e)}
                            className="ns-selection-dropdown-sort-menu"
                            options={options}
                            label={'Sort by'}
                        />
                    </div>
                </div>
            </div>
        </div>
    ) : (
        ''
    )
}
